import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Integracje',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: '{{company}} nie ma skonfigurowanych integracji.',
  },
  buttons: {
    add_integration: 'Dodaj integrację',
  },
  toasts: {
    error: 'Nie udało się zapisać zmian',
    success: 'Zmiany zostały zapisane',
    load_error: 'Nie udało się załadować integracji',
  },
};
